import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import type { LegalDocument } from '../data/policies';
interface PolicyModalProps {
  document: LegalDocument | null;
  onClose: () => void;
}
export function PolicyModal({
  document: doc,
  onClose
}: PolicyModalProps) {
  useEffect(() => {
    if (!doc) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.document.addEventListener('keydown', onKeyDown);
    window.document.body.style.overflow = 'hidden';
    return () => {
      window.document.removeEventListener('keydown', onKeyDown);
      window.document.body.style.overflow = '';
    };
  }, [doc, onClose]);
  return <AnimatePresence data-id="element-30" data-mp="1tfrvrle3hl69">
      {doc && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" role="dialog" aria-modal="true" aria-labelledby="policy-modal-title" data-id="element-31" data-mp="czfhs8cm45b8">
          <motion.button type="button" aria-label="Cerrar" onClick={onClose} className="absolute inset-0 h-full w-full cursor-default bg-navy/60" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-32" data-mp="27k5p76qcajl1" />

          <motion.div className="relative flex max-h-[85vh] w-full max-w-lg flex-col overflow-hidden rounded-3xl bg-ivory" initial={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} transition={{
        duration: 0.26,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-33" data-mp="2qhgk6f4xuquo">
            <header className="flex items-start justify-between gap-4 border-b border-line px-6 py-5 sm:px-8" data-id="element-34" data-mp="39884gbqgs1nu">
              <div data-id="element-35" data-mp="349wu7zw9bp53">
                <h2 id="policy-modal-title" className="font-display text-2xl font-extrabold tracking-tight text-navy" data-id="element-36" data-mp="34ag02i8mun2r">
                  {doc.title}
                </h2>
                <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-mute" data-id="element-37" data-mp="25y3swtl6zp0q">
                  {doc.updatedAt}
                </p>
              </div>
              <button type="button" onClick={onClose} aria-label="Cerrar" className="shrink-0 rounded-full p-2 text-navy transition-colors duration-200 ease-smooth hover:bg-navy hover:text-ivory focus:outline-none focus-visible:ring-2 focus-visible:ring-cobalt" data-id="element-38" data-mp="2fof6l7uohckt">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-39" data-mp="2tl21z66zfuom" />
              </button>
            </header>

            <div className="flex-1 overflow-y-auto px-6 py-6 sm:px-8" data-id="element-40" data-mp="2yjvjd9pe45u2">
              <div className="space-y-6" data-id="element-41" data-mp="zaoqf2qaaxut">
                {doc.sections.map(section => <section key={section.heading} data-id="element-42" data-mp="148qj8fdiibjh">
                    <h3 className="text-[11px] font-bold uppercase tracking-wide text-cobalt" data-id="element-43" data-mp="woflxh2w5vva">
                      {section.heading}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-mute" data-id="element-44" data-mp="rwo3jttw2wg8">{section.body}</p>
                  </section>)}
              </div>
            </div>

            <footer className="border-t border-line px-6 py-4 sm:px-8" data-id="element-45" data-mp="i0umbx586es4">
              <button type="button" onClick={onClose} className="w-full rounded-full bg-lime px-6 py-3 text-xs font-bold uppercase tracking-wide text-navy transition-colors duration-200 ease-smooth hover:bg-lime-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-cobalt" data-id="element-46" data-mp="1fo3c44c9e9zx">
                Cerrar
              </button>
            </footer>
          </motion.div>
        </div>}
    </AnimatePresence>;
}